export default "__VITE_ASSET__DOW0hBlc__"